import { FC } from "react";
import { useQueryClient } from "@tanstack/react-query";
import Throbber from "@/components/throbber";
import { useReactivateCardSubscription } from "@/hooks/use-mutations";

// Shown under the card when its subscription has expired. Renewing uses the
// reactivate endpoint, the same call as the cancelled-card panel.
export const SubscriptionExpiredPanel: FC<{ card: Card }> = ({ card }) => {
  const queryClient = useQueryClient();
  const { mutate: renew, isPending } = useReactivateCardSubscription({
    id: card.id,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cardInfo", card.id] });
      queryClient.invalidateQueries({
        queryKey: ["cardSubscription", card.id],
      });
      queryClient.invalidateQueries({ queryKey: ["cards"] });
    },
  });

  return (
    <div className="mt-4 rounded-2xl border border-[#F87171]/60 bg-[#F87171]/10 p-4 text-white">
      <p className="text-base font-medium">Subscription Expired</p>
      <p className="mt-1 text-xs text-white/60">
        Your card is no longer active. Renew your subscription to continue using
        your card.
      </p>
      <button
        type="button"
        onClick={() => renew()}
        disabled={isPending}
        className="mt-4 flex h-11 w-full items-center justify-center rounded-lg bg-[#FF6B6B] text-sm font-medium text-white hover:bg-[#FF6B6B]/90 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {isPending ? <Throbber /> : "Renew subscription"}
      </button>
    </div>
  );
};
